import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import {MuiThemeProvider} from '@material-ui/core/styles';
import ProjectDialog from '../CreateDialogue/ProjectDialog';
import ProjectGroupDialog from '../CreateDialogue/ProjectGroupDialog';
import EditProjectDialog from '../EditDialogue/EditProjectDialog';
import {muiThemeDesign} from '../../mui-theme-design';
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

export default function ProjectsTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [projects, setprojects] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [AlertText, setAlertText] = React.useState('');

    React.useEffect(() => {

        if (refresh) {
            fetch('api/project', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setprojects(json);
					setIsLoading(false);
				})

            setRefresh(false);
        }
    })

    const handleDialogCallback = (childData) => {
        fetch("api/project", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "project": [{
                    "ProjectGroupID": childData.ProjectGroupID,
                    "Name": childData.Name,
                    "IsActive": childData.IsActive,
                    "StartDate":moment.utc(childData.StartDate),
                    "EndDate": moment.utc(childData.EndDate),
                    "ProjectGroupName": childData.ProjectGroupName
                }]
            })
        }).then(res => res.json())
        .then(json => {
            if (json.code === 'ER_DUP_ENTRY') {
                setAlertText(json.message)
                setAlert(true)
            }
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/project", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "project": {
                    "ID": childData.ID,
                    "ProjectGroupID": childData.ProjectGroupID,
                    "Name": childData.Name,
                    "ExistingName": childData.ExistingName,
    				"ExistingProjectGroupID": childData.ExistingProjectGroupID,    
                    "IsActive": childData.IsActive,
                    "StartDate": moment.utc(childData.StartDate),
                    "EndDate": moment.utc(childData.EndDate),
                    "ProjectGroupName": childData.ProjectGroupName
                }
            })
        }).then(res => res.json())
        .then(json => {
            if (json.code === 'ER_DUP_ENTRY') {
                setAlertText(json.message)
                setAlert(true)
            }
        })
        logger(childData);
        setRefresh(true);
    };
    
    const handleGroupDialogCallback = (childData) => {
        fetch("api/projectGroup", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "projectGroup": [{
                    "ProjectGroup": childData.ProjectGroup
                }]
            })
        })
        logger(childData);
        setRefresh(true);
    };
    
    const handleAlertClose = () => {
        setAlert(false);
    };
	

    const columns = [];
    if (permissions.CreateProjects == 1) {
       	const adminActions =  {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditProjectDialog handleEditCallback={handleEditCallback} data={projects[dataIndex]} />
                        </div>
                    );
                }

            }
        };
        columns.push(adminActions);
    }
     const columns1 = [
        {
            name: "Name",
            label: "Project",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "ProjectGroup",
            label: "Project Group",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "StartDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(projects[dataIndex].StartDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "EndDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(projects[dataIndex].EndDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    }
                },
                filterOptions: {
                    renderValue: val => {
                        if (val === 0) {
                            return "InActive";
                        }
                        if (val === 1) {
                            return "Active";
                        }
                        return val;
                    }

                },
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(projects[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>

                    )

                } 
            }
        }
    ];
    
     columns.push(...columns1);

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('ProjectrowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('ProjectrowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				for (var i = 0; i < projects.length; i++) {
					var eachRow = data[i].data;
					eachRow[3] =  moment.utc(eachRow[3]).format("MM/DD/YYYY")
					eachRow[4] =  moment.utc(eachRow[4]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'Project.xlsx', columnIndexToRemove:0} )
			return false;
		},
        customToolbar: () => permissions.CreateProjects===1 && !isLoading ? (
			<>
			<ProjectDialog handleDialogCallback={handleDialogCallback} />
			<ProjectGroupDialog handleGroupDialogCallback={handleGroupDialogCallback} />
			</>
		):(<></>)
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="projectTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Projects
                        </Typography>
                    }
                    data={isLoading ? [] :projects}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}

                />
                </Box>
            </MuiThemeProvider>
            <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="Project">
                    {"Duplicate Entry"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}